import { createContext } from 'react'

import NavbarStore from '../stores/NavbarStore/NavbarStore'

export const NavbarStoreContext = createContext<NavbarStore | null>(null)
